// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Apple_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M15.55 6.804a6.01 6.01 0 0 0 3.2-5.304.75.75 0 0 0-.75-.75h-.75A6 6 0 0 0 12 3.85 6 6 0 0 0 6.75.75H6a.75.75 0 0 0 0 1.5h.75a4.51 4.51 0 0 1 4.444 3.79 8.25 8.25 0 1 0 4.356.764Zm1.637-4.554A4.51 4.51 0 0 1 12.813 6a4.51 4.51 0 0 1 4.374-3.75ZM12 21a6.75 6.75 0 1 1 6.75-6.75A6.76 6.76 0 0 1 12 21Zm5.24-5.876a5.39 5.39 0 0 1-4.366 4.366 1 1 0 0 1-.124.01.75.75 0 0 1-.123-1.49 3.87 3.87 0 0 0 3.134-3.134.75.75 0 0 1 1.48.248Z',
  viewBox: '0 0 24 24',
  glyph: 'Apple_Stroke2_Corner0_Rounded',
})
